import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
// import { isMobile } from 'react-device-detect'
import routeView from './route/routeView'
import LeftMenu from './route/LeftBar'
import Signer from './route/Signer'
import Logout from './route/Logout'
import { routersHelper } from './helpers'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import PopupStatus from './helpers/PopupStatus'

import useGoogleAnalytics from './libs/googleAnalytics'
import useGoogleTagManagers from './libs/googleTagManagers'

import VroomSurvey from './components/Survey/VroomSurvey'

const Router = () => {
    const { useRouter } = routersHelper
    const router = useRouter()
    const spinner = useSelector(state => state.backgroundRunning.spinner)
    const { pathname } = router

    var jwt = new URLSearchParams(window.location.search).get("jwt");
    if (jwt) {
        window.history.pushState('', 'VROOM', '/portal');
    }

    useGoogleAnalytics();
    useGoogleTagManagers();

    return (
        <>
            <Spin spinning={spinner}>
                <PopupStatus />
                {
                    (
                        pathname !== "/portal/rejoin" &&
                        pathname !== "/portal/error" &&
                        pathname !== "/portal/survey"
                    )
                        ? <LeftMenu />
                        : <div />
                }
                <Switch>
                    <Route exact path="/portal/signer" component={Signer} />
                    <Route exact path="/portal/logout" component={Logout} />
                    <Route exact path="/portal/survey" component={VroomSurvey} />
                    <Route exact path="/portal" component={routeView} />
                    <Route exact path="/portal/:name" component={routeView} />
                    <Route exact path="/portal/profile/edit" component={routeView} />
                    <Redirect to="/portal" />
                </Switch>
            </Spin>
        </>
    )
}

export default Router